export var CapitalActionNoticeStatus;
(function (CapitalActionNoticeStatus) {
    CapitalActionNoticeStatus["Draft"] = "draft";
    CapitalActionNoticeStatus["Published"] = "published";
})(CapitalActionNoticeStatus || (CapitalActionNoticeStatus = {}));
//# sourceMappingURL=index.js.map